import React from "react";
import { DebitNoteFormPage } from "./DebitNote/DebitNote";
import { CreditNoteFormPage } from "./CreditNote/CreditNote";
import { ReceiptFormPage } from "./Receipt/Receipt";
import DebitNoteView from "./DebitNote/DebitNoteView";
import CreditNoteView from "./CreditNote/CreditNoteView";
import ReceiptView from "./Receipt/ReceiptView";
import DebitNotePrint from "./DebitNote/Print";
import CreditNotePrint from "./CreditNote/Print";
import ReceiptPrint from "./Receipt/Print";
import { StitchFormShell } from "../../../../shared-ui/StitchFormShell";

export function StitchDebitNoteFormPage() {
  return (
    <StitchFormShell crumbs={["Operations", "ZOrder", "AR", "Debit Note"]} title="Debit note form">
      <DebitNoteFormPage />
    </StitchFormShell>
  );
}
export function StitchCreditNoteFormPage() {
  return (
    <StitchFormShell crumbs={["Operations", "ZOrder", "AR", "Credit Note"]} title="Credit note form">
      <CreditNoteFormPage />
    </StitchFormShell>
  );
}
export function StitchReceiptFormPage() {
  return (
    <StitchFormShell crumbs={["Operations", "ZOrder", "AR", "Receipt"]} title="Receipt form">
      <ReceiptFormPage />
    </StitchFormShell>
  );
}
export function StitchDebitNoteViewPage() {
  return (
    <StitchFormShell crumbs={["Operations", "ZOrder", "AR", "Debit Note"]} title="Debit note" print>
      <DebitNoteView />
    </StitchFormShell>
  );
}
export function StitchCreditNoteViewPage() {
  return (
    <StitchFormShell crumbs={["Operations", "ZOrder", "AR", "Credit Note"]} title="Credit note" print>
      <CreditNoteView />
    </StitchFormShell>
  );
}
export function StitchReceiptViewPage() {
  return (
    <StitchFormShell crumbs={["Operations", "ZOrder", "AR", "Receipt"]} title="Receipt" print>
      <ReceiptView />
    </StitchFormShell>
  );
}
export function StitchDebitNotePrintPage() {
  return (
    <StitchFormShell crumbs={["Operations", "ZOrder", "AR", "Debit Note Print"]} title="Debit note print" print>
      <DebitNotePrint />
    </StitchFormShell>
  );
}
export function StitchCreditNotePrintPage() {
  return (
    <StitchFormShell crumbs={["Operations", "ZOrder", "AR", "Credit Note Print"]} title="Credit note print" print>
      <CreditNotePrint />
    </StitchFormShell>
  );
}
export function StitchReceiptPrintPage() {
  return (
    <StitchFormShell crumbs={["Operations", "ZOrder", "AR", "Receipt Print"]} title="Receipt print" print>
      <ReceiptPrint />
    </StitchFormShell>
  );
}
